import { render } from "./SentenceExplanationContent.vue?vue&type=template&id=62796e71&scoped=true"
import script from "./SentenceExplanationContent.vue?vue&type=script&lang=js"
export * from "./SentenceExplanationContent.vue?vue&type=script&lang=js"

import "./SentenceExplanationContent.vue?vue&type=style&index=0&id=62796e71&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62796e71"]])

export default __exports__